import * as LucideIcons from 'lucide-react';

// Curated set of attractive icons that admins can choose from
export const ICON_OPTIONS = [
  'Sparkles', 'Book', 'BookOpen', 'BookMarked', 'Radio', 'Calendar', 'CalendarDays',
  'Heart', 'HeartHandshake', 'HandHeart', 'HandCoins', 'Store', 'ShoppingBag',
  'Home', 'Clock', 'Moon', 'Star', 'Sun', 'Compass', 'Users', 'Gift',
  'Mail', 'Phone', 'Megaphone', 'Bell', 'Landmark', 'Building2', 'Library',
  'MapPin', 'Video', 'Tv', 'Music', 'Mic', 'Headphones', 'GraduationCap',
  'Stethoscope', 'Utensils', 'Wallet', 'PiggyBank', 'Coins', 'Award',
  'Flag', 'Newspaper', 'Droplet', 'Flower2',
];

// Attractive emerald & gold themed color palette
export const COLOR_OPTIONS = [
  '#10B981', '#065F46', '#022C22', '#D4AF37', '#FBBF24', '#0EA5E9',
  '#8B5CF6', '#EC4899', '#EF4444', '#F97316', '#14B8A6', '#6366F1',
];

export const getIcon = (name) => LucideIcons[name] || LucideIcons.Circle;
